export abstract class IStorageService {
    abstract getItem(key: string): string | null;
    abstract setItem(key: string, data: string): void;
    abstract clear(): void;
    abstract removeItem(key: string);
    abstract hasItem(key: string): boolean;
}
